import {Component, OnInit, Input, IterableDiffers, DoCheck, inject, Renderer2} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ThemeService } from 'src/app/_services/theme.service';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
    selector: 'app-custom-data-table',
    templateUrl: './custom-data-table.component.html',
    styleUrls: ['./custom-data-table.component.scss'],
    standalone: false
})
export class CustomDataTableComponent implements OnInit, DoCheck {
  private readonly themeService: ThemeService = inject(ThemeService);
  private readonly renderer: Renderer2 = inject(Renderer2);
  private readonly overlayContainer: OverlayContainer = inject(OverlayContainer);
  private readonly iterableDiffers: IterableDiffers = inject(IterableDiffers);

  @Input() tableData;
  @Input() columnHeader;
  @Input() ariaLabel;
  objectKeys = Object.keys;
  dataSource;
  iterableDiffer: any;
  theme: string;

  constructor() {
    this.iterableDiffer = this.iterableDiffers.find([]).create(null);
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource( this.tableData );
    this.themeService.themeApplied.subscribe(
      theme => {
        if (this.theme) {
          this.renderer.removeClass(document.body, this.theme);
          this.overlayContainer.getContainerElement().classList.remove(this.theme);
        }
        this.renderer.addClass(document.body, theme);
        this.overlayContainer.getContainerElement().classList.add(theme);
        this.theme = theme;
      }
    );
  }

  ngDoCheck() {
    const changes = this.iterableDiffer.diff(this.tableData);
    if (changes) {
      this.dataSource = new MatTableDataSource( this.tableData );
    }
  }
}
